"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _TermsAndConditions = _interopRequireDefault(require("./TermsAndConditions"));

var _termsModule = require("./termsModule");

var _listingModule = require("../listing/listingModule");

var _AnalyticsModule = require("../analytics/modules/AnalyticsModule");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  return {
    terms: state.terms,
    sharedInfo: state.sharedInfo,
    userId: state.userPrefs.userId,
    listing: state.listing,
    companyUUID: state.userPrefs.companyUUID
  };
}

var mapDispatchToProps = {
  toggleModal: _termsModule.toggleTaCModal,
  toggleNeedAnAccountClicked: _listingModule.toggleNeedAnAccountClicked,
  launchModal: _termsModule.launchTaCModal,
  updateTermsStatus: _termsModule.updateCurrentlyAccepted,
  postTerms: _termsModule.updateTerms,
  connect: _listingModule.connectListing,
  trackButtonClick: _AnalyticsModule.buttonClickDispatch,
  trackLinkClick: _AnalyticsModule.linkClickDispatch
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TermsAndConditions.default);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/terms/TermsContainer.js
// module id = 266
// module chunks = 0